var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamificationStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 24,
    transform: "matrix(1 0 0 -1 24 23.9998)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9188 21.8015C32.7025 21.1386 32.1122 20.7102 31.4149 20.7102H26.9184L25.5024 16.4101C25.2847 15.7491 24.6956 15.323 24.0004 15.323C23.9999 15.323 21.8908 22.4719 21.8908 22.4719L23.9999 29.6208L27.6496 32.2862C28.2142 32.6984 28.9447 32.6998 29.5108 32.2896C30.0768 31.8794 30.303 31.1847 30.087 30.5199L28.6917 26.2257H28.7105L32.3478 23.5695C32.9109 23.1584 33.1351 22.4643 32.9188 21.8015Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9939 15.323C23.2958 15.3258 22.7069 15.7571 22.4938 16.422L21.1191 20.7102H16.5851C15.8861 20.7102 15.2953 21.14 15.0801 21.8051C14.8649 22.4702 15.0919 23.1645 15.6585 23.5741L19.3118 26.2147L17.9129 30.5199C17.6969 31.1847 17.9231 31.8793 18.4891 32.2895C19.0552 32.6997 19.7857 32.6984 20.3503 32.2861L24.0001 29.6208C24.0002 29.6208 24.0002 15.323 24.0002 15.323C23.9981 15.323 23.9959 15.323 23.9939 15.323Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationStar);
export default __webpack_public_path__ + "static/media/gamification-star.89eeebcb3456ac8bcdbdbb37f4f2258a.svg";
export { ForwardRef as ReactComponent };